export const timePattern = /^(0?[1-9]|1[0-2]):[0-5][0-9]$/